import CustomCurrencyFormat from 'components/CustomCurrencyFormat';
import React from 'react';

function OrderHistoryList({ orders }) {
  const totalOrders = orders?.edges.length;
  return (
    <>
      <div className="main">
        {orders?.edges?.map((item) => {
          const order = item.node;
          return (
            <ul key={order.id} className="order-item">
              <ListItem label={'Order Number'} value={order.orderNumber} />
              <ListItem label={'Date'} value={order.date || '-'} />
              <ListItem
                label={'Total'}
                value={
                  <CustomCurrencyFormat value={order.totalPriceV2.amount} />
                }
              />
              <ListItem label={'Status'} value={order.status || '-'} />
              <a className="view-link" href={order.statusUrl}>
                View
              </a>
            </ul>
          );
        })}
      </div>

      <style jsx>{`
        .main {
          display: grid;
          grid-template-columns: repeat(1, minmax(0, 1fr));
          gap: 10px;
        }
        .view-link {
          text-decoration: underline;
          cursor: pointer;

          font-family: 'Roboto-Medium';
          font-size: 13px;
          font-weight: 400;
          line-height: 20px;
          letter-spacing: 0em;
          text-align: right;
          color: #ffffff;
        }
        .order-item {
          background-color: #141414;
          padding: 20px;
          border-radius: 10px;
          display: grid;
          gap: 10px;
        }
        @media (max-width: 768px) {
          .main {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }
        }
        @media (max-width: 640px) {
          .main {
            grid-template-columns: repeat(1, minmax(0, 1fr));
          }
        }
      `}</style>
    </>
  );
}
function ListItem({ label, value }) {
  return (
    <li className="list-item">
      <div className="label">{label}:</div>
      <div className="value">{value}</div>
      <style jsx>
        {`
          .list-item {
            width: 100%;
            display: flex;
            font-family: 'Roboto-Medium';
            justify-content: space-between;
            gap: 10px;
            align-items: center;
            font-size: 13px;
          }
          .label {
            text-transform: uppercase;
            color: #949494;
          }
          .value {
            text-align: right;
          }
        `}
      </style>
    </li>
  );
}
export default OrderHistoryList;
